import { postRequest } from "./AxiosHelper"
import {
    MarketingFormData,
    SetDownloadedRequest,
    SubmitMarketingFormRequest,
} from "../types/Marketing"

type UpdateUserContactRequest = MarketingFormData | SetDownloadedRequest

export const updateUserContact = async (data: UpdateUserContactRequest) => {
    const debRouteName = "api.crm.sync"
    const debRoute = route(debRouteName)

    return postRequest<UpdateUserContactRequest, any>(debRoute, data)
}

export type MarketingSignupRequest = {
    email: string
    interest_in_windows?: boolean
}

export type MarketingSignupResponse = {
    success: boolean
    message: string
    data: HubspotContactResponse
}

export interface HubspotContactResponse {
    id: string
    properties: {
        email: string
        [key: string]: any
    }
    createdAt: string
    updatedAt: string
    archived: boolean
}

export const submitEmailMarketing = (data: MarketingSignupRequest) => {
    const debRouteName = "api.crm.marketing-signup"
    const debRoute = route(debRouteName)

    return postRequest<MarketingSignupRequest, MarketingSignupResponse>(
        debRoute,
        data
    )
}

export const submitForm = ({
    formKey,
    data,
}: {
    data: SubmitMarketingFormRequest
    formKey: "beta_survey" | "partner_contact" | "sales_contact"
}) => {
    const url = route("api.crm.form", { formKey })
    return postRequest<SubmitMarketingFormRequest, boolean>(url, data)
}
